class DigitalCampaignSplash extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    let source = this.getAttribute("src");
    this.innerHTML =
    `
    <div class="splashImage">
        <div class ="col-md-5 startCampaign">
          <div class="col-md-offset-3"> 
            <h6>Manage all your Online Analytics</h6>
            
            <br>
              <div class= "form-inline">
                <label for="addDomainName">Please enter Domain Name</label>
                <br>
                <input type=hidden value="1" name="domain[web_analytics]">
                <input type="text" name="domain[domain_name]" class="form-control" id="addDomainName" aria-describedby="inputDomain">
                <button type="submit" class="btn btn-success col-auto" data_save_action="save_continue" style="margin-left: 5px">Start</button>
                <p id="inputDomain">e.g., yourdomain.com</p>
              </div>
          </div>
        </div>
 
    </div>
   
    
   `;
  }
}

customElements.define("digital-campaign-splash", DigitalCampaignSplash);